import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import moment from "moment";
import { DataTable } from "../../../components/tables";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { AdminService } from "../../../app/service/admin.service";
import { ConversionsDataGridCols } from "./data-grid-cols";

const BdiStudentList = () => {
  const [usersData, setUsersData] = useState<any[]>([]); // original
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]); // filtered
  const [selectedUserValue,setSelectedUserValue]=useState<any>({});

  const [name, setName] = useState("");
  const [date, setDate] = useState("");


  const navigate = useNavigate();

  const handleCancel = () => {
    setName("");
    setFilteredUsers(usersData);
    getUsers();
    setDate("");
  };

  const handleSearch = () => {
    const filteredData = usersData.filter((item: any) => {
      // 🔹 Name filter
      const nameMatch = name
        ? `${item.name}`.toLowerCase().includes(name.toLowerCase())
        : true;

      // 🔹 Date filter
      const dateMatch = date
        ? moment(item.createdAt).format("YYYY-MM-DD") === date
        : true;

      return nameMatch && dateMatch;
    });

    setFilteredUsers(filteredData);
  };

  useEffect(() => {
    getUsers();
  }, []);

  const handleBdiAccess = (data: any) => {
    const userdata: any = sessionStorage.getItem("loginData");
    const userRole = JSON.parse(userdata);
    const payloadData = {
      isVerify: true,
      accessByBdi: userRole.email,
      cEmail: data.email,
    };
    AdminService.updateConversionList(payloadData).then((res: any) => {
      if (res.status === "Success") {
      } else {
        toast.error(res.message);
      }
    });
  };

  const getUsers = () => {
    const userdata: any = sessionStorage.getItem("loginData");
    const userRole = JSON.parse(userdata);
    const payloadData = {
      assignedBdiId: userRole.id,
    };
    AdminService.getBdiUsersList(payloadData).then((res: any) => {
      if (res.status === "Success") {
        const formattedData = res?.data?.map((item: any) => ({
          ...item,
          createdAt: moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
        }));

        setUsersData(formattedData);
        setFilteredUsers(formattedData)
      } else {
        toast.error(res.message);
      }
    });
  };

  let bdiMessageData = [
    "NA",
    "INTERESTED",
    "CALL BACK",
    "PAID",
    "ONBOARDED",
    "NI",
  ];

  const bOptionss = bdiMessageData?.map((type: any) => ({
    value: type,
    label: type,
  }));

  const handleSelectChanges = (selectedOption: any, { name }: any) => {
    const payloadData = {
        uploadStudentId:selectedUserValue?._id,
        userId:selectedUserValue?.assignedBdi,
        message:selectedOption.value
    };
    AdminService.assignBdiAndUpdateMessage(payloadData).then((res: any) => {
      if (res.status === "Success") {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>
        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>
          <div className="col-md-10 mt-3">
            <label className="form-label d-flex justify-content-start text-start">
              <b> Students List</b>
            </label>
            <div className="d-flex">
              <input
                name="User Name"
                onChange={(e: any) => setName(e.target.value)}
                className="form-control mt-1 me-2"
                value={name}
                placeholder="Enter the EmailId / Phone No"
              />
              <input
                type="date"
                name="Date"
                onChange={(e: any) => setDate(e.target.value)}
                className="form-control mt-1 me-2"
                value={date}
              />
              <button
                className="btn btn-primary rounded px-4 py-1"
                onClick={handleSearch}
              >
                Search
              </button>
              <button
                className="btn btn-secondary rounded ms-2 px-4 py-1"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>

            <div className="mt-5">
              <DataTable
                tableData={filteredUsers}
                TableCols={ConversionsDataGridCols}
                handleBdiAccess={handleBdiAccess}
                bOptionss={bOptionss}
                handleSelectChanges={handleSelectChanges}
                setSelectedUserValue={setSelectedUserValue}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BdiStudentList;
